import React from 'react'
import cx from 'classnames'
import { Svgs } from '../../constants/images'
import Tooltip from 'react-simple-tooltip'

export interface ICheckbox extends React.HTMLAttributes<HTMLInputElement> {
  name: string
  title: string
  checked?: boolean
  info?: string
}

const Checkbox = function ({
  name,
  title,
  className,
  info,
  checked = false,
  onClick,
  ...props
}: ICheckbox) {
  return (
    <div className={cx(className, 'ocla-checkbox')}>
      <input
        checked={checked}
        className='ocla-checkbox__input'
        type='checkbox'
        name={name}
        id={name}
        onClick={onClick}
        {...props}
      />
      <label htmlFor={name} className='ocla-checkbox__label'>
        {title}
      </label>
      {info && (
        <Tooltip
          content={<div className='ocla-checkbox__info-text'>{info}</div>}
          placement='right'
          fadeDuration={300}
        >
          <img className='ocla-checkbox__info-icon' src={Svgs.info} />
        </Tooltip>
      )}
    </div>
  )
}

export default React.memo(Checkbox)
